import clsx from 'clsx';
import { memo } from 'react';

import './Divider.css';

export type DividerProps = {
  /** Line orientation. @default 'horizontal' */
  direction?: 'horizontal' | 'vertical';
};

export const Divider = memo(({ direction = 'horizontal' }: DividerProps) => {
  return (
    <div
      aria-hidden
      className={clsx('eds-divider', `eds-divider--direction-${direction}`)}
    />
  );
});

Divider.displayName = 'Divider';
